import React from 'react';
import BackButton from '../components/BackButton';
import { useTranslation, Trans } from 'react-i18next';
import Navbar from '../components/Navbar';

export default function SobreNosotros() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="container mx-auto px-4 md:px-6 max-w-3xl py-12">
        <BackButton />
        <h1 className="text-4xl font-heading font-bold text-[#134168] mb-2">{t('legal.aboutTitle')}</h1>
        <p className="text-sm text-gray-400 mb-8">{t('legal.aboutSubtitle')}</p>

        <div className="bg-white rounded-3xl p-8 shadow-sm space-y-6 text-gray-700 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-bold text-[#134168] mb-2">{t('legal.aboutMissionTitle')}</h2>
            <p>{t('legal.aboutMissionText')}</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#134168] mb-2">{t('legal.aboutHowTitle')}</h2>
            <p>{t('legal.aboutHowText')}</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#134168] mb-2">{t('legal.aboutTeamTitle')}</h2>
            <p><Trans i18nKey="legal.aboutTeamText" /></p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#134168] mb-2">{t('legal.aboutContactTitle')}</h2>
            <p>{t('legal.aboutContactText')} <a href="mailto:info@redmobility.com" className="text-[#134168] hover:underline">info@redmobility.com</a></p>
          </section>
        </div>
      </div>
    </div>
  );
}
